var __makeTemplateObject = (this && this.__makeTemplateObject) || function (cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};
import React from "react";
import styled from "styled-components";
import { Button, RatingBar } from "..";
var OverviewWrapper = styled.div(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n  display: grid;\n  grid-template-columns: auto auto;\n  grid-gap: 5px;\n  justify-content: left;\n"], ["\n  display: grid;\n  grid-template-columns: auto auto;\n  grid-gap: 5px;\n  justify-content: left;\n"])));
var RatingOverview = function (_a) {
    var ratings = _a.ratings;
    return (React.createElement(OverviewWrapper, null,
        React.createElement(RatingBar, { rating: 1 }),
        React.createElement(Button, { emphasis: "primary", variant: "text" },
            "(",
            ratings[1],
            ")"),
        React.createElement(RatingBar, { rating: 2 }),
        React.createElement(Button, { emphasis: "primary", variant: "text" },
            "(",
            ratings[2],
            ")"),
        React.createElement(RatingBar, { rating: 3 }),
        React.createElement(Button, { emphasis: "primary", variant: "text" },
            "(",
            ratings[3],
            ")"),
        React.createElement(RatingBar, { rating: 4 }),
        React.createElement(Button, { emphasis: "primary", variant: "text" },
            "(",
            ratings[4],
            ")"),
        React.createElement(RatingBar, { rating: 5 }),
        React.createElement(Button, { emphasis: "primary", variant: "text" },
            "(",
            ratings[5],
            ")")));
};
export default RatingOverview;
var templateObject_1;
